// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-5765e814]{position:relative;opacity:0;overflow:hidden}.wrapper_active[data-v-5765e814]{opacity:1;transition:opacity .2s ease-out}.wrapper__child[data-v-5765e814]{height:0;position:absolute;top:0;left:0;transform-origin:left top}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
